import { Pipe, PipeTransform } from '@angular/core'
import { firstItemUpper } from '../util/util'

export function humanReadable(value: unknown, ...args: unknown[]) {
  if (value === undefined || value === null || value === '') {
    return ''
  }
  if (typeof value === 'string') {
    if (!isNaN(parseFloat(value))) {
      return value
    }

    // specific terminology:
    switch (value.toLowerCase()) {
      case 'mas':
        return 'mAs'
      case 'sdnr':
        return 'SDNR'
      case 'rmi':
        return 'RMI'
      case 'cnr':
        return 'CNR'
      case 'snr':
        return 'SNR'
      default:
        // general case:
        return value
          .replace(/_/gm, ' ')
          .replace(/-/gm, ' ')
          .split(' ')
          .map(firstItemUpper)
          .join(' ')
    }
  } else {
    return value
  }
}

@Pipe({
  name: 'humanReadable',
})
export class HumanReadablePipe implements PipeTransform {
  transform = humanReadable
}
